<template>
  <div ref="div" class="dropdown" :class="{ active: show }">
    <label ref="clicked" class="icon">
      <slot name="icon">
        <i class="bx" :class="icon" :style="{ color }" />
      </slot>
      <input type="checkbox" v-model="show" class="hidden" />
      <!-- <span>{{ label }}</span> -->
    </label>
    <div
      v-if="show"
      class="menu"
      :class="[props.class, { '[&>div.active]:bg-gray-lighter [&>div:hover]:outline [&>:hover]:bg-accent-room': !noHover }]"
    >
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, type Ref } from 'vue';

const props = defineProps<{
  icon?: string;
  noautohide?: boolean;
  noHover?: boolean;
  color?: string;
  class?: string | object | any[];
}>();

const show = defineModel('active', {
  type: Boolean,
  default: false,
});

const div = ref(null) as Ref<HTMLDivElement | null>;
const clicked = ref(null) as Ref<HTMLDivElement | null>;

if (!props.noautohide) {
  document.addEventListener('click', (ev) => {
    if (clicked.value?.contains(ev.target as HTMLElement)) return;
    show.value = false;
  });
}
</script>

<style scoped>
div.dropdown {
  position: relative;
}

div.dropdown > .icon {
  width: 32px;
  height: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

div.dropdown > .icon > i,
div.dropdown > .icon > :deep(svg) {
  color: white;
}

div.dropdown > .icon:hover {
  background: rgba(255, 255, 255, 0.5);
}

div.dropdown > div.menu {
  position: absolute;
  top: 30px;
  left: 0px;
  z-index: 10;
  font-size: 18px;
  text-align: left;
  white-space: nowrap;
  display: flex;
  flex-direction: column;
  background: white;
  cursor: pointer;
  min-width: 150px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}

div.dropdown > div.menu > :deep(*) {
  padding: 5px 5px;
  gap: 4px;
}

div.dropdown > div.menu > :deep(*) > i {
  font-size: 20px;
}

div.dropdown.active > .icon {
  background: var(--color-accent-icon);
}

div.dropdown.active > .icon > i {
  color: black;
}
</style>
